export default __webpack_public_path__ + "static/media/spark_20.67820234.png";